import '@ant-design/compatible/assets/index.css';
import { useQuery } from 'react-query';
import React from 'react';
import { Modal, Card, notification, Popconfirm } from 'antd';
import DF from 'DisplayFramework';
import { StepBackwardOutlined } from '@ant-design/icons';
import { findFinModificationByAnyRefOrStatus } from 'services/fincontract';
import ModalControllerNV from 'components/ModalControllerNV';
import GetLabel from 'DisplayFramework/components/GetLabel';
import Button from 'components/Button';
import TabFinModificationRestore from 'pages/workflow/tabFinModificationRestore';
import { finModRestore, getProcTaskInit } from 'services/workflow';
import Form, { useForm } from 'antd/lib/form/Form';
import modal from 'antd/lib/modal';
import ButtonOperation from 'components/ButtonOperation';

export type TabFinModificationRestoreModalProps = {
  objectid: number;
  modevent?: string;
  modstatus?: string;
  modId?: any;
  modctreference?: string;
  isTab?: boolean;
  onSelect?: any;
};
const TabFinModificationRestoreModal = ({
  objectid,
  modevent,
  modstatus,
  modId,
  onSelect,
  modctreference,
  isTab,
}: TabFinModificationRestoreModalProps) => {
  const [form] = useForm();
  const initialValues = {
    modid: 0,
    reason: '',
    comment: '',
  };
  const {
    data: modList,
    refetch,
    isFetching,
  } = useQuery(['findFinModificationByAnyRefOrStatus', objectid], () =>
    findFinModificationByAnyRefOrStatus({
      ctreference: '',
      modevent: '',
      modstatus: 'VALID',
      modtype: 'EVENT',
      ctrid: objectid ?? 0,
    })
      .then((res) => {
        const rawData: any = res.list;
        const maxModIdsArray: any = Object.values(
          rawData.reduce((acc: any, item: any) => {
            const { ctreference, modid, eventlabel, modevent, ctrid } = item;

            if (!acc[ctreference] || modid > acc[ctreference].modid) {
              acc[ctreference] = {
                ctreference,
                modid,
                eventlabel,
                modevent,
                ctrid,
              };
            }

            return acc;
          }, {})
        );
        return maxModIdsArray;
      })
      .catch((err) => [])
  );

  const { data: dataProcTask } = useQuery(
    ['getProcTaskInit'],
    () =>
      getProcTaskInit({
        entity: 'CONTRACT',
        entityid: 0,
        funcode: 'evFinModRestore',
        action: '',
        prcode: '',
      }).then((res) => res.list || []),
    {}
  );

  const onSave = () => {
    const taskIds: number[] | undefined = dataProcTask?.map((s) => s.taskid);

    const req = {
      comment: form.getFieldValue('comment'),
      event: form.getFieldValue('modevent'),
      modid: form.getFieldValue('modid'),
      entity: 'CONTRACT',
      entityId: objectid ?? form.getFieldValue('ctrid'),
      objectreference: form.getFieldValue('objectreference'),
      reason: form.getFieldValue('reason'),
      subentity: 'FINMOD',
      subentityid: 0,
      taskid: taskIds ? taskIds[0] : 0,
    };

    return finModRestore({
      req: req,
    });
  };

  return (
    <DF.Provider pagcode="restoremanager">
      <Form form={form} initialValues={initialValues}>
        <ModalControllerNV
          modal={({ setVisible, visible }) => (
            <Modal
              open={visible}
              onCancel={() => {
                setVisible(false);
              }}
              width={1200}
              destroyOnClose
              title={<GetLabel label="TabFinModificationRestore" />}
              footer={[
                <Button
                  key="Cancel"
                  comcode="Cancel"
                  onClick={() => setVisible(false)}
                  style={{ width: '100px' }}
                />,
                <Popconfirm
                  title="Are you sure to restore this event?"
                  key="Valid"
                  onConfirm={() => {
                    onSave().then((response) => {
                      if (response.success === true) {
                        notification.success({
                          message: response.message,
                        });
                        setVisible(false);
                      } else {
                        notification.error({
                          message: 'Restore failed',
                        });
                      }
                    });
                  }}
                >
                  <ButtonOperation
                    key="Valid"
                    comcode="Valid"
                    style={{ width: '100px' }}
                    type="primary"
                  />
                </Popconfirm>,
              ]}
            >
              <Card>
                <TabFinModificationRestore
                  objectid={objectid}
                  modId={modId}
                  form={form}
                  onSelect={(e: any) => {
                    onSelect(e);
                  }}
                />
              </Card>
            </Modal>
          )}
          content={({ setVisible, visible }) => (
            <ButtonOperation
              comcode="restore"
              icon={<StepBackwardOutlined />}
              onClick={() => {
                let mod = modList.find((mod: any) => mod.modid === modId);
                if (mod || isTab) {
                  setVisible(true);
                } else {
                  const reference = modList[0].ctreference;
                  const eventlabel = modList[0].eventlabel;
                  const modid = modList[0].modid;

                  const label =
                    ' ' + reference + ' - ' + modid + ' - ' + eventlabel;

                  const confirm = {
                    title: 'This is not the last event!',
                    content: (
                      <>
                        The event that should be restored is:
                        <span style={{ color: 'red' }}>{label}</span>
                      </>
                    ),
                    onOk() {
                      return false;
                    },
                    onmouseout() {
                      return false;
                    },
                  };
                  modal.error(confirm);
                }
              }}
              style={{ ...(isTab ? { height: '40px', width: '100px' } : {}) }}
            />
          )}
        />
      </Form>
    </DF.Provider>
  );
};
export default TabFinModificationRestoreModal;
